import { useState } from "react";
import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import NewsCard from "@/components/feature/NewsCard";

interface NewsPreviewProps {
  news: NewsItem[];
}

const STEP = 3;

export default function NewsPreview({ news }: NewsPreviewProps) {
  const [visible, setVisible] = useState(3);

  const shown = news.slice(0, visible);
  const hasMore = visible < news.length;

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <h2 className="font-heading font-semibold text-2xl md:text-3xl text-foreground-950">
            影视资讯精选
          </h2>
          <p className="mt-1.5 text-sm text-foreground-600">
            剧集动态、行业观察与深度访谈，掌握影视圈最新风向
          </p>
        </div>
        <Link
          to="/news"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
        >
          全部资讯
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="flex flex-col gap-3 md:gap-4">
        {shown.map((item) => (
          <NewsCard key={item.id} item={item} />
        ))}
      </div>

      <div className="mt-7 flex justify-center">
        {hasMore ? (
          <button
            type="button"
            onClick={() => setVisible((prev) => prev + STEP)}
            className="h-11 px-6 inline-flex items-center gap-2 rounded-md border border-background-300 text-foreground-700 font-heading text-sm tracking-wide hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            加载更多资讯
            <i className="ri-arrow-down-line"></i>
          </button>
        ) : (
          <Link
            to="/news"
            className="h-11 px-6 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading text-sm tracking-wide hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        )}
      </div>
    </section>
  );
}